export interface OfflineBannerProps {
  isOnline: boolean;
}

export function OfflineBanner({ isOnline }: OfflineBannerProps) {
  if (isOnline) return null;

  return (
    <div
      data-testid="offline-banner"
      role="alert"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: '#f59e0b',
        color: '#000',
        textAlign: 'center',
        padding: '8px 16px',
        zIndex: 9999,
        fontWeight: 500,
      }}
    >
      You are offline. Some features may be unavailable.
    </div>
  );
}
